/**
 * Block palette preferences — the Recent and Favorites name lists (Faz 5.8,
 * OCS palette tabs) persisted in localStorage. Names resolve against the
 * live useBlockStore.defs at render time, so stale entries are simply
 * filtered out instead of cleaned up.
 */

const RECENT_KEY = 'yap-block-recent';
const FAVORITES_KEY = 'yap-block-favorites';
const RECENT_CAP = 20;

function readList(key: string): string[] {
    try {
        const raw = localStorage.getItem(key);
        const list = raw ? (JSON.parse(raw) as unknown) : [];
        return Array.isArray(list) ? list.filter((v): v is string => typeof v === 'string') : [];
    } catch {
        return [];
    }
}

function writeList(key: string, list: string[]): void {
    try { localStorage.setItem(key, JSON.stringify(list)); } catch { /* storage unavailable */ }
}

/** Recently placed block names (newest first), capped at 20. */
export function readRecentBlocks(): string[] {
    return readList(RECENT_KEY);
}

/** Record a placement (called from the shared placeBlock path). */
export function pushRecentBlock(name: string): void {
    writeList(RECENT_KEY, [name, ...readList(RECENT_KEY).filter((n) => n !== name)].slice(0, RECENT_CAP));
}

/** Favorited block names (insertion order). */
export function readFavoriteBlocks(): string[] {
    return readList(FAVORITES_KEY);
}

/** Toggle favorite membership; returns the new state. */
export function toggleFavoriteBlock(name: string): boolean {
    const current = readList(FAVORITES_KEY);
    const isFav = current.includes(name);
    writeList(FAVORITES_KEY, isFav ? current.filter((n) => n !== name) : [...current, name]);
    return !isFav;
}
